import { Badge } from '@/components/ui/badge'
import dayjs from '@/lib/dayjs'
import { cn } from '@/lib/utils'
import { CalendarDaysIcon } from 'lucide-react'

export function CommunityEstablishedBadge({ className, createTs }) {
  if (createTs == null) return null

  const createdAt = dayjs.utc(createTs)

  if (!createdAt.isValid()) return null

  return (
    <Badge
      aria-label={`Established ${createdAt.format('D MMMM YYYY')}`}
      className={cn(
        'gap-1.5 border-neutral-blue-600 bg-neutral-blue-700 px-2.5 py-1 text-[11px] tracking-wide text-neutral-blue-100',
        className,
      )}
      variant="outline"
    >
      <CalendarDaysIcon aria-hidden="true" className="size-3.5" />
      <time dateTime={createdAt.format('YYYY-MM-DD')}>
        EST. {createdAt.format('D MMM YYYY').toUpperCase()}
      </time>
    </Badge>
  )
}
